import React, { useState, useCallback } from "react";
import { debounce } from "lodash";
import InputAdornment from "@material-ui/core/InputAdornment";
import { iconNew, RotaButtonIcon } from "@teamrota/rota-design";

import {
  SearchInputWrapper,
  useStyles,
  StyledTooltip
} from "~/src/containers/scheduler/SearchInput/search-input.styles";

import FilterContent from "./FilterContent";

const { Search, Filter } = iconNew;

const SearchInput = ({
  schedule,
  setRoleIds,
  setSortBy,
  sortBy,
  setVenueIds,
  setSearchTerm,
  setHomeVenueIds,
  searchTerm
}) => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(false);
  const [searchInput, setSearchInput] = useState(searchTerm);

  const debounceLoadData = useCallback(debounce(setSearchTerm, 1000), [
    searchInput
  ]);

  const handleSearch = value => {
    setSearchInput(value);
    debounceLoadData(value);
  };

  return (
    <>
      <div className={classes.root}>
        <SearchInputWrapper
          autoFocus
          name="queryText"
          variant="filled"
          id="custom-css-outlined-input"
          onChange={event => handleSearch(event.target.value)}
          value={searchInput}
          InputProps={{
            classes,
            placeholder: "Search...",
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            )
          }}
        />

        <div>
          <StyledTooltip>
            <RotaButtonIcon onClick={() => setIsOpen(!isOpen)}>
              <Filter />
            </RotaButtonIcon>

            <FilterContent
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              schedule={schedule}
              setRoleIds={setRoleIds}
              setSortBy={setSortBy}
              sortBy={sortBy}
              setVenueIds={setVenueIds}
              setHomeVenueIds={setHomeVenueIds}
            />
          </StyledTooltip>
        </div>
      </div>
    </>
  );
};

export default SearchInput;
